export default __webpack_public_path__ + "images/f09b38201574f790513e926a223590ff-pyx-pets.svg";